import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { decodeId } from "../../utils/idObfuscator";
import { useGetShopByIdQuery } from "../../features/shop/shopApiSlice";
import { useGetMyManagedShopsQuery } from "../../features/shop/shopMemberApiSlice";

const ShopManagebuttons = ({
  businessurl,
  shopid,
  isOwner: propIsOwner,
  shopData: propShopData,
}) => {
  const navigate = useNavigate();

  const [isMarketerHandeling, SetisMarketerHandeling] = useState(false);
  useEffect(() => {
    const marketerId = localStorage.getItem("MeAsmarketerId");
    const previousRoute = localStorage.getItem("previousRoute");

    if (previousRoute === "marketing-clients" && marketerId) {
      SetisMarketerHandeling(true);
    }
  }, []);

  const cleanShopId = decodeId(shopid) || shopid || "";

  const currentUser = useSelector(
    (state) => state?.user?.name || state?.auth?.user,
  );
  const currentUserId = currentUser?._id || currentUser?.id;

  const { data: shopRes } = useGetShopByIdQuery(cleanShopId, {
    skip: !cleanShopId || Boolean(propShopData),
  });

  const { data: managedShopsRes } = useGetMyManagedShopsQuery(undefined, {
    skip: !currentUserId,
  });

  const resolvedShop = propShopData || shopRes?.data?.Shop;
  const shopOwnerId = resolvedShop?.userid?._id || resolvedShop?.userid;

  const managedShops = Array.isArray(managedShopsRes?.data?.managedShops)
    ? managedShopsRes.data.managedShops
    : Array.isArray(managedShopsRes?.data)
      ? managedShopsRes.data
      : [];

  const currentMembership = managedShops.find((m) => {
    const rawSid = m?.shopId?._id || m?.shopId;
    const sId = decodeId(rawSid) || rawSid;
    return (
      sId &&
      (String(sId) === String(cleanShopId) ||
        String(sId) === String(shopid) ||
        String(rawSid) === String(cleanShopId) ||
        String(rawSid) === String(shopid))
    );
  });
  const isManagedMember = Boolean(currentMembership);
  const memberAccessAreas = currentMembership?.accessAreas || [];

  const isOwner = Boolean(
    typeof propIsOwner === "boolean"
      ? propIsOwner && !isManagedMember
      : currentUserId &&
        shopOwnerId &&
        String(currentUserId) === String(shopOwnerId) &&
        !isManagedMember,
  );

  let showGiveAdminRights = false;
  if (isManagedMember) {
    showGiveAdminRights = false;
  } else if (typeof propIsOwner === "boolean") {
    showGiveAdminRights = propIsOwner;
  } else if (currentUserId && shopOwnerId) {
    showGiveAdminRights = String(currentUserId) === String(shopOwnerId);
  }

  // When User B accepts admin access and manages User A's shop, do not show Business Dashboard to User B.
  // The Business Dashboard is strictly reserved for the actual shop owner (User A).
  const canAccessBusinessDashboard =
    Boolean(businessurl) && isOwner && !isManagedMember && !isMarketerHandeling;

  return (
    <>
      <div className="d-flex justify-content-end">
        {canAccessBusinessDashboard && (
          <div>
            <button
              className="btn-primary pt-1 pb-1 rounded"
              onClick={() => businessurl && navigate(businessurl)}
            >
              Business Dashboard
            </button>
          </div>
        )}

        {showGiveAdminRights && (
          <div>
            &nbsp;&nbsp;
            <button
              className="btn-primary pt-1 pb-1 rounded"
              onClick={() =>
                navigate(
                  cleanShopId ? `/ShopManage/${cleanShopId}` : "/ShopManage",
                  { state: { shopId: cleanShopId || shopid } },
                )
              }
            >
              Give Admin Rights For This Shop
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default ShopManagebuttons;
